import { Navigate, useParams } from "react-router-dom";

export default function RedirectTo({ to }) {

    const params = useParams();

    const path = Object.entries(params).reduce(
        (resolved, [key, value]) => resolved.replace(`:${key}`, value),
        to
    );

    return <Navigate to={path} replace />;
}
